import SetupUser from './SetupUser'

export default SetupUser
